// @ts-nocheck
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import style from "../../templates/payment/Dashboard.module.scss";
import { Modal } from "react-bootstrap";
import { LicenseChangeModal } from "./LicenseChangeModal";
import { setFullPageFlg } from "../../../reducks/store/Settings/slices";
import { useTranslation } from "react-i18next";

export const DashBoardCurrentPlan = ({
  client,
  currentPlan,
  planName,
  operationCount,
  userLicense,
  membersCount,
  fetchLicenseDowngradeInfo,
  getNextPayment,
  defaultLicenseCount,
  is_internal,
}) => {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const [currentUserLicense, setCurrentUserLicense] = useState(userLicense);
  const { t } = useTranslation();

  return (
    <div
      className={`${style.currentPlanWrap} ${
        planName === t("DashBoardCurrentPlan.フリー")
          ? style.free
          : planName === t("DashBoardCurrentPlan.ミニ") ||
            planName === t("DashBoardCurrentPlan.スタンダード") ||
            planName === t("DashBoardCurrentPlan.プラス")
          ? style.mini
          : planName === t("DashBoardCurrentPlan.チーム") ||
            planName === t("DashBoardCurrentPlan.プロ") ||
            planName === t("DashBoardCurrentPlan.ビジネス")
          ? style.team
          : style.success
      }`}
    >
      {/* グラデーションのデザインを重ねて付与 */}
      <div
        className={`${style.currentPlanGradation} ${
          planName === t("DashBoardCurrentPlan.フリー")
            ? style.freeGradation
            : planName === t("DashBoardCurrentPlan.ミニ") ||
              planName === t("DashBoardCurrentPlan.スタンダード") ||
              planName === t("DashBoardCurrentPlan.プラス")
            ? style.miniGradation
            : planName === t("DashBoardCurrentPlan.チーム") ||
              planName === t("DashBoardCurrentPlan.プロ") ||
              planName === t("DashBoardCurrentPlan.ビジネス")
            ? style.teamGradation
            : style.successGradation
        }`}
      ></div>
      <div className="w-100">
        {planName !== t("DashBoardCurrentPlan.フリー") && (
          <span className={style.currentPlanInterval}>{currentPlan.interval}</span>
        )}

        <div className="w-100 my-2 d-flex justify-content-between">
          <div
            className={`${style.currentPlanName} ${
              planName === t("DashBoardCurrentPlan.フリー") || planName === t("DashBoardCurrentPlan.フリー")
                ? style.freePlanName
                : planName === t("DashBoardCurrentPlan.ミニ") ||
                  planName === t("DashBoardCurrentPlan.スタンダード") ||
                  planName === t("DashBoardCurrentPlan.プラス")
                ? style.miniPlanName
                : planName === t("DashBoardCurrentPlan.チーム") ||
                  planName === t("DashBoardCurrentPlan.プロ") ||
                  planName === t("DashBoardCurrentPlan.ビジネス")
                ? style.teamPlanName
                : style.successPlanName
            }`}
          >
            {planName}
          </div>
          <button
            className={`btn btn-info test-change-plan font-weight-bold ${style.changePlanBtn}`}
            style={{ borderRadius: "30px", position: "relative" }}
            onClick={() => dispatch(setFullPageFlg(true))}
            data-testid="test-change-plan-btn"
          >
            {t("DashBoardCurrentPlan.プラン変更")}
          </button>
        </div>

        <>
          <div className="w-100 d-flex justify-content-between" style={{ marginTop: "32px" }}>
            <div className="w-100 d-flex flex-column">
              <div className={`m-0 ${style.currentTaskRunsLabel}`}>{t("DashBoardCurrentPlan.今月のタスク実行数")}</div>
              <div className={style.currentTaskRunsValue}>{operationCount.toLocaleString()}</div>
            </div>
            <div className="w-100 d-flex flex-column" style={{ marginLeft: "24px" }}>
              {is_internal && (
                <>
                  <div className={`m-0 ${style.currentTaskRunsLabel}`}>
                    {t("DashBoardCurrentPlan.現在のライセンス数")}
                  </div>
                  <div className={style.currentTaskRunsValue}>{currentUserLicense?.toLocaleString()}</div>
                </>
              )}
            </div>
            {is_internal &&
              planName !== t("DashBoardCurrentPlan.フリー") &&
              planName !== t("DashBoardCurrentPlan.ミニ") && (
                <div
                  className={`w-25 d-flex flex-column align-self-center ${style.licenseChangeLink}`}
                  style={{ zIndex: "100", marginTop: "28px", cursor: "pointer" }}
                  onClick={() => {
                    handleShow();
                  }}
                  data-testid="test-change-license-count"
                >
                  {t("DashBoardCurrentPlan.変更")}
                </div>
              )}
          </div>
          <Modal
            size="md"
            show={show}
            onHide={handleClose}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ zIndex: "1501" }}
          >
            <Modal.Body>
              <LicenseChangeModal
                client={client}
                handleClose={handleClose}
                currentUserLicense={currentUserLicense}
                membersCount={membersCount}
                currentPlan={currentPlan}
                setCurrentUserLicense={setCurrentUserLicense}
                fetchLicenseDowngradeInfo={fetchLicenseDowngradeInfo}
                getNextPayment={getNextPayment}
                defaultLicenseCount={defaultLicenseCount}
              />
            </Modal.Body>
          </Modal>
        </>
        {currentPlan && currentPlan.schedule.end && currentPlan.interval && (
          <>
            <div className="w-100 d-flex flex-column" style={{ marginTop: "32px" }}>
              <div className={`m-0 ${style.currentTaskRunsLabel}`}>
                {t("DashBoardCurrentPlan.契約期間（自動更新）")}
              </div>
              {planName === t("DashBoardCurrentPlan.フリー") ? (
                <div className={style.currentSchedule}>-</div>
              ) : (
                <div className={style.currentSchedule}>
                  {currentPlan.schedule.start}〜{currentPlan.schedule.end}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

DashBoardCurrentPlan.propTypes = {
  client: PropTypes.string,
  currentPlan: PropTypes.object,
  planName: PropTypes.string,
  operationCount: PropTypes.number,
  userLicense: PropTypes.number,
  membersCount: PropTypes.number,
  fetchLicenseDowngradeInfo: PropTypes.func,
  getNextPayment: PropTypes.func,
  defaultLicenseCount: PropTypes.number,
  is_internal: PropTypes.bool,
};
